export default __webpack_public_path__ + "static/media/ic_whiteheart.812925cb.svg";